import { GestureTapHoldIcon } from './GestureTapHoldIcon';

/**
 * author: Google
 * id B502F4A5-5545-42F7-A0B4-E90BF4421D17
 * name gesture-tap-hold
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gesture-tap-hold.svg
 * tags
 */
export const GestureTouchHoldIcon = GestureTapHoldIcon;
export default GestureTouchHoldIcon